var _rect, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBankDataRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3560_28513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3560_28513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50012 17V8.99998H7.50012V17H6.50012ZM11.5001 17V8.99998H12.5001V17H11.5001ZM3.53857 20V19H20.4617V20H3.53857ZM16.5001 17V8.99998H17.5001V17H16.5001ZM3.53857 6.99998V6.15383L12.0001 2.11536L20.4617 6.15383V6.99998H3.53857ZM6.1809 5.99998H17.8193L12.0001 3.24998L6.1809 5.99998Z",
    fill: "#15B79E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3560_28513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3560_28513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0652 16.359C26.2355 16.359 26.3805 16.2988 26.5002 16.1786C26.6198 16.0583 26.6796 15.913 26.6796 15.7427C26.6796 15.5723 26.6195 15.4273 26.4993 15.3077C26.379 15.188 26.2337 15.1282 26.0634 15.1282C25.893 15.1282 25.748 15.1883 25.6284 15.3086C25.5087 15.4288 25.4489 15.5741 25.4489 15.7445C25.4489 15.9148 25.509 16.0598 25.6293 16.1795C25.7495 16.2991 25.8948 16.359 26.0652 16.359ZM25.6348 13.6202H26.4184C26.4398 13.2024 26.501 12.9046 26.6019 12.7268C26.7029 12.5489 26.8629 12.3467 27.0819 12.1202C27.5787 11.6373 27.9075 11.2452 28.0683 10.9439C28.2291 10.6426 28.3095 10.3262 28.3095 9.99475C28.3095 9.35186 28.103 8.80419 27.6901 8.35173C27.2772 7.89927 26.7416 7.67304 26.0835 7.67304C25.5675 7.67304 25.0864 7.81514 24.6404 8.09933C24.1943 8.38353 23.8671 8.76494 23.6588 9.24356L24.404 9.58171C24.5931 9.1394 24.8258 8.83999 25.1019 8.68348C25.3781 8.52695 25.6807 8.44869 26.0098 8.44869C26.4948 8.44869 26.8757 8.58651 27.1524 8.86217C27.4291 9.13781 27.5675 9.48823 27.5675 9.91344C27.5675 10.2436 27.4652 10.5256 27.2606 10.7596C27.056 10.9936 26.8217 11.2393 26.5579 11.4968C26.1999 11.8451 25.9566 12.1776 25.8279 12.4944C25.6991 12.8111 25.6348 13.1864 25.6348 13.6202ZM26.003 19.1666C25.0214 19.1666 24.0949 18.9803 23.2236 18.6075C22.3522 18.2347 21.5893 17.7214 20.9347 17.0675C20.2802 16.4135 19.7663 15.6513 19.3932 14.7809C19.0201 13.9104 18.8335 12.9843 18.8335 12.0028C18.8335 11.0073 19.0199 10.0774 19.3926 9.21298C19.7654 8.34858 20.2788 7.5891 20.9327 6.93454C21.5866 6.28 22.3488 5.76616 23.2193 5.39302C24.0898 5.01988 25.0158 4.83331 25.9974 4.83331C26.9928 4.83331 27.9228 5.01969 28.7872 5.39246C29.6516 5.76524 30.411 6.27858 31.0656 6.9325C31.7201 7.58642 32.234 8.34515 32.6071 9.20869C32.9803 10.0722 33.1668 11.0017 33.1668 11.9972C33.1668 12.9788 32.9804 13.9052 32.6077 14.7766C32.2349 15.6479 31.7216 16.4109 31.0676 17.0654C30.4137 17.72 29.655 18.2338 28.7915 18.6069C27.9279 18.9801 26.9984 19.1666 26.003 19.1666Z",
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBankDataRegistryIcon);
export default __webpack_public_path__ + "static/media/empty-bank-data-registry-icon.989480b4b8c188e265e35b92a5f6d8d5.svg";
export { ForwardRef as ReactComponent };